<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full">
      <template #title>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="8" :md="8">
            <a-button
              type="primary"
              icon="plus"
              size="small"
              @click="AddClick"
              v-if="isAdmin"
            >
              新增词汇
            </a-button>
          </a-col>

          <a-col
            :span="16"
            :md="16"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-input
              v-model="Query.skey"
              placeholder="模糊词汇"
              size="small"
              style="width: 150px; margin-right: 10px"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="margin-right: 10px"
              @click="SearchClieck(0)"
            >
              查询
            </a-button>
          </a-col>
        </a-row>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="12" :md="12">
            <a-button
              type="primary"
              icon="arrow-down"
              size="small"
              style="margin-right: 10px"
              @click="GrabBySearch()"
              v-show="false"
              v-if="isAdmin"
            >
              按照条件抓取
            </a-button>

            <a-button
              type="primary"
              icon="check"
              size="small"
              style="margin-right: 10px"
              @click="GrabAllKeys()"
              v-if="isAdmin"
            >
              全部抓取
            </a-button>

            <a-button
              type="danger"
              icon="delete"
              size="small"
              @click="DelAllKeys()"
              v-if="isAdmin"
            >
              清空任务
            </a-button>
          </a-col>
          <a-col
            :span="12"
            :md="12"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="margin-right: 10px"
              @click="SearchClieck(3)"
            >
              查询(综合指数倒序)
            </a-button>
          </a-col>
        </a-row>

        <a-row type="flex" align="top" :gutter="16">
          <a-col :span="24">
            <el-table
              size="medium"
              :data="tableData"
              :stripe="true"
              style="width: 100%; border: 1px solid #e4e7ed"
              @sort-change="sortChange"
            >
              <el-table-column prop="keyWord" label="词汇"> </el-table-column>
              <el-table-column prop="wciKeyWord" label="微指词汇">
              </el-table-column>
              <el-table-column prop="tkKeyWord" label="抖指词汇">
              </el-table-column>
              <el-table-column
                prop="lastWeekWciScore"
                label="上周微指平均"
                sortable="custom"
                width="180"
              >
              </el-table-column>
              <el-table-column
                prop="lastWeekTkScore"
                label="上周抖指平均"
                sortable="custom"
                width="180"
              >
              </el-table-column>
              <el-table-column prop="addUserName" label="添加人" width="100">
              </el-table-column>
              <el-table-column
                prop="lastUpdateTime"
                label="更新时间"
                width="210"
              >
              </el-table-column>
              <el-table-column prop="date" label="数据" width="80">
                <template slot-scope="{row}">
                  <span class="icon" @click.stop="OpenKeywordChart(row)">
                    <svg
                      t="1763434425676"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="4712"
                      width="32"
                      height="32"
                    >
                      <path
                        d="M85.504 938.688H1024V1024H0v-85.312h0.192V0h85.312v938.688zM128 723.328l212.736-271.552 303.424 155.52L990.912 256v632.64H128v-165.312z"
                        fill="#ffffff"
                        p-id="4713"
                      ></path>
                    </svg>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="视频" width="80">
                <template slot-scope="{row}">
                  <span
                    class="icon"
                    @click.stop="OpenVideoPage(row)"
                    v-if="row.isHaveVideo"
                  >
                    <svg
                      t="1770703186074"
                      class="icon"
                      viewBox="0 0 1087 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5571"
                      width="256"
                      height="256"
                    >
                      <path
                        d="M768 415.744q0 5.12-10.752 17.92t-23.04 30.208-23.04 37.888-10.752 41.984 10.752 41.472 23.04 36.352 23.04 27.136 10.752 13.824l0 107.52q0 17.408-12.8 39.424t-31.744 41.472-41.984 32.256-43.52 12.8l-508.928 0q-27.648 0-50.688-9.728t-40.448-27.136-27.136-40.96-9.728-51.2l0-441.344q0-20.48 9.216-42.496t26.112-40.448 39.936-30.72 50.688-12.288l508.928 0q27.648 0 51.712 9.728t41.984 26.624 28.16 40.448 10.24 50.176l0 89.088zM1086.464 319.488l0 467.968q0 22.528-11.776 39.936t-35.328 17.408q-8.192 0-20.992-6.144t-25.6-14.336-24.064-16.384-16.384-13.312q-13.312-11.264-40.448-38.912t-54.784-62.464-48.64-71.68-20.992-67.584 22.528-70.144 54.272-77.312 66.56-70.144 58.368-48.64q9.216-6.144 25.088-14.848t28.16-8.704q27.648 0 35.84 15.36t8.192 37.888l0 2.048z"
                        p-id="5572"
                        fill="#ffffff"
                      ></path>
                    </svg>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="lastMonthVideoNum"
                label="上月视频数量"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="totalVideoNum"
                label="采集视频量"
                width="120"
              >
              </el-table-column>
              <el-table-column prop="date" label="操作" width="410" v-if="isAdmin">
                <template slot-scope="{row}">
                  <el-button
                    type="primary"
                    round
                    size="small"
                    icon="el-icon-edit"
                    style="margin-right: 5px"
                    @click.stop="EditClick(row)"
                    >编辑</el-button
                  >

                  <el-button
                    type="warning"
                    round
                    size="small"
                    icon="el-icon-share"
                    style="margin-right: 5px"
                    @click.stop="GrabSingle(row)"
                    >抓取</el-button
                  >

                  <el-button
                    type="info"
                    round
                    size="small"
                    icon="el-icon-link"
                    style="margin-right: 5px"
                    @click.stop="SetTkIndexUrl(row)"
                    >抖音主页设置</el-button
                  >

                  <el-button
                    type="danger"
                    round
                    size="small"
                    icon="el-icon-delete"
                    style="margin-right: 5px"
                    @click.stop="DelClick(row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <div class="PageCom">
              <el-pagination
                background
                :current-page="Page.index"
                :page-sizes="Page.sizes"
                :page-size="Page.size"
                :total="Page.total"
                layout="sizes, total, prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </a-col>
        </a-row>
      </template>
    </a-card>
  </div>
</template>

<script>
import { getShowBizList, showBizDel } from "@/api/showbiz.js";
import { grabSbInfoByIds, delAllTask } from "@/api/grab";
import store from "@/store";
export default {
  data() {
    return {
      Query: {
        skey: "",
        orderType: 0,
      },
      tableData: [],
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 50, 100, 200, 500, 1000],
        total: 0,
      },
      isAdmin: store.getters.roles.includes("admin"),
    };
  },
  created() {
    this.GetTableData();

    if (this.isAdmin) {
      this.columns.push({
        title: "操作",
        key: "editBtn",
        scopedSlots: { customRender: "editBtn" },
      });
    }
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.GetTableData(this.Query);
    },
    handleCurrentChange(val) {
      this.Page.index = val;
      this.GetTableData(this.Query);
    },
    GetTableData() {
      getShowBizList(
        this.Query.skey,
        this.Page.index,
        this.Page.size,
        this.Query.orderType
      ).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.Page.total = res.data.total;
        }
      });
    },
    sortChange({ column, prop, order }) {
      if (prop == "lastWeekWciScore") {
        if (order == "ascending") {
          this.Page.index = 1;
          this.Query.orderType = 4;
          this.GetTableData();
        } else if (order == "descending") {
          this.Page.index = 1;
          this.Query.orderType = 1;
          this.GetTableData();
        } else {
          ///null   按照id倒序排列
          this.Page.index = 1;
          this.Query.orderType = 0;
          this.GetTableData();
        }
      }
      if (prop == "lastWeekTkScore") {
        if (order == "ascending") {
          this.Page.index = 1;
          this.Query.orderType = 5;
          this.GetTableData();
        } else if (order == "descending") {
          this.Page.index = 1;
          this.Query.orderType = 2;
          this.GetTableData();
        } else {
          ///null   按照id倒序排列
          this.Page.index = 1;
          this.Query.orderType = 0;
          this.GetTableData();
        }
      }
      // this.Query.orderType = column.prop;
      // this.GetTableData();
    },
    AddClick() {
      this.$emit("addClick");
    },
    SearchClieck(orederType) {
      this.Page.index = 1;
      this.Query.orderType = orederType;
      this.GetTableData();
    },
    EditClick(row) {
      this.$emit("editClick", row);
    },
    DelClick(row) {
      this.$confirm("此操作将永久删除此关键字, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          showBizDel(row.id).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.GetTableData();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    GrabSingle(row) {
      grabSbInfoByIds([row.id]).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    GrabAllKeys() {
      grabSbInfoByIds([]).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    DelAllKeys() {
      this.$confirm("此操作将清空所有任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delAllTask().then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },

    SetTkIndexUrl(row) {
      console.log("SetTkIndexUrl", row);
      this.$emit("setTkIndexUrl", row.id);
    },
    OpenKeywordChart(row) {
      try {
        // 直接构建完整URL，不依赖Vue Router的resolve方法
        const baseUrl = window.location.origin + window.location.pathname;
        const queryString = `?id=${row.id}`;
        const fullUrl = baseUrl + "#/showbiz_keyword-chart" + queryString;

        console.log("直接构建的完整URL:", fullUrl);

        // 添加防缓存参数
        const timestamp = new Date().getTime();
        const urlWithTimestamp =
          fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

        const newWindow = window.open(urlWithTimestamp, "_blank");

        if (newWindow === null || typeof newWindow === "undefined") {
          console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
          window.location.href = urlWithTimestamp;
        }
      } catch (error) {
        console.error("跳转错误:", error);
        this.$router.push({
          path: "/showbiz_keyword-chart",
          query: { id: row.id },
        });
      }
    },
    OpenVideoPage(row) {
      try {
        // 直接构建完整URL，不依赖Vue Router的resolve方法
        const baseUrl = window.location.origin + window.location.pathname;
        const queryString = `?id=${row.id}`;
        const fullUrl = baseUrl + "#/showbizvideo" + queryString;

        console.log("直接构建的完整URL:", fullUrl);

        // 添加防缓存参数
        const timestamp = new Date().getTime();
        const urlWithTimestamp =
          fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

        const newWindow = window.open(urlWithTimestamp, "_blank");

        if (newWindow === null || typeof newWindow === "undefined") {
          console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
          window.location.href = urlWithTimestamp;
        }
      } catch (error) {
        console.error("跳转错误:", error);
        this.$router.push({
          path: "/showbizvideo",
          query: { id: row.id },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  background-color: #1296db;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin: 7px;
  vertical-align: middle;
  cursor: pointer;
}
</style>